/*
*  グローバル変数：店舗データ
*/
//夜コース料金
var pubCoursePrice;

//飲み放題料金
var pubNomihoPrice;

//コースフラグ
var courseFlg = "";


/*
*  定数：店舗データ
*/
//昼コース料金
const DAY_COURSE_PRICE = "2000";

//割引率(%)
const DISCOUNT_RATE = 20;


/*
*  画面読込時、初期値設定イベント
*/
function initPage() {

	//初期値に設定
	refresh_Shop_Data();

	//デフォルト(昼)設定		
	change_Course();
}


/*
*　"ご利用コース"ドロップダウンリスト選択時のイベント
*/
function change_Course() {

	//"昼"選択時
	if ($('.courseSelect').val() == "day") {

		//コースフラグの更新
		courseFlg = "DAY";

		//チェックを外し、非活性にする:DOM操作
		ctl_Radio_Dom("DISABLE");


		//"夜"選択時
	} else if ($('.courseSelect').val() == "night") {

		//コースフラグの更新
		courseFlg = "NIGHT";

		//店舗が選択されている場合
		if ($('.js-shop-name').val() !== "" && $('.js-shop-name').val() !== "選択してください") {

			//データをラジオボタンに反映する
			if (pubCoursePrice == "3000") {
				//DOM操作
				ctl_Radio_Dom("LEFT");
			} else if (pubCoursePrice == "3500") {
				//DOM操作
				ctl_Radio_Dom("RIGHT");
			}


			//店舗が選択されていない場合
		} else {
			//活性化する
			ctl_Radio_Dom("NONE");

		}

		//選択なし
	} else {
		courseFlg = "";

		ctl_Radio_Dom("");
	}
}

/*
*　"都道府県"ドロップダウンリスト選択時のイベント
*/
function estimate_change_prefectures(_this) {
	var val = _this.val();
	var csv_file = _this.parents('.select_arrow').attr('data-csv-file');

	$.ajax({
		type: 'POST',
		url: ajaxurl,
		data: {
			'action': 'prefectures_change_shop_option',
			'prefectures_slug': val,
			'csv_file': csv_file,
		},
		success: function (data) {
			$('.js-shop-name').html(data);

			//店舗ドロップダウンを初期化するので、店舗データの初期化を実行
			refresh_Shop_Data();
			//DOMを活性化する
			ctl_Radio_Dom("NONE");

		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("リクエスト時になんらかのエラーが発生しました：" + textStatus + ":\n" + errorThrown);
		}

	});
}

/*
*　"店舗"ドロップダウンリスト選択時のイベント
*/
function shop_change_price(_this) {
	var val = _this.val();
	var csv_file = _this.parents('.select_arrow').attr('data-csv-file');

	$.ajax({
		type: 'POST',
		url: ajaxurl,
		data: {
			'action': 'shop_change_price',
			'shop_id': val,
			'csv_file': csv_file,
		},
		success: function (data) {
			
			var jsonData = $.parseJSON(data)

			//店舗ドロップダウンリストが選択されている場合
			if ($('.js-shop-name').val() !== "" && $('.js-shop-name').val() !== "選択してください") {

				//コース価格を取得して設定(3000 or 3500)
				pubCoursePrice = jsonData["コース料金"];
				//飲み放題価格を取得して設定(デフォルトで1500円?)
				pubNomihoPrice = jsonData["飲み放題料金"];

				//一応、クラスに設定(デフォルト値1500円)
				$('.nomihoAri').val(pubNomihoPrice);

				//取得した価格をラジオボタンに反映
				if (pubCoursePrice == "3000") {
					//DOM操作
					ctl_Radio_Dom("LEFT");
				} else if (pubCoursePrice == "3500") {
					//DOM操作
					ctl_Radio_Dom("RIGHT");
				}


				//店舗ドロップダウンリストが未選択の場合
			} else {

				//店舗データ初期化
				refresh_Shop_Data();
				//チェックを外す:DOM操作
				ctl_Radio_Dom("NONE");

			}

		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("リクエスト時になんらかのエラーが発生しました：" + textStatus + ":\n" + errorThrown);
		}

	});
}


//店舗データ初期化
function refresh_Shop_Data() {

	//コース価格初期化
	pubCoursePrice = "0";
	//飲み放題価格初期化
	pubNomihoPrice = "0";

}


//コース金額ラジオボタンのDOM操作
function ctl_Radio_Dom(pattern) {

	//利用コースが"夜"の場合
	if (courseFlg == "NIGHT") {

		switch (pattern) {
			//非活性:チェックなし 必要なし
			case "DISABLE":
				//console.log("非活性:チェックなし");	
				$('._3000').prop('disabled', true);
				$('._3500').prop('disabled', true);
				$('._3000').prop('checked', false);
				$('._3500').prop('checked', false);
				$('.price3000YEN').addClass("disabled");
				$('.price3500YEN').addClass("disabled");
				break;

			//活性：チェックなし
			case "NONE":
				//console.log("活性：チェックなし");	
				$('._3000').prop('disabled', false);
				$('._3500').prop('disabled', false);
				$('._3000').prop('checked', true);
				$('._3500').prop('checked', false);
				$('.price3000YEN').removeClass("disabled");
				$('.price3500YEN').removeClass("disabled");
				break;

			//非活性:チェックあり(3000)
			case "LEFT":
				//console.log("非活性:3000");	
				$('._3000').prop('disabled', false);
				$('._3500').prop('disabled', true);
				$('._3000').prop('checked', true);
				$('._3500').prop('checked', false);
				$('.price3000YEN').removeClass("disabled");
				$('.price3500YEN').addClass("disabled");
				break;

			//活性:チェックあり(3500)
			case "RIGHT":
				//console.log("非活性:3500");	
				$('._3000').prop('disabled', true);
				$('._3500').prop('disabled', false);
				$('._3000').prop('checked', false);
				$('._3500').prop('checked', true);
				$('.price3000YEN').addClass("disabled");
				$('.price3500YEN').removeClass("disabled");
				break;
		}
		//利用コースが昼の場合
	} else if (courseFlg == "DAY") {
		//非活性のまま
		//console.log("昼：非活性:チェックなし");	

		$('._3000').prop('disabled', true);
		$('._3500').prop('disabled', true);
		$('._3000').prop('checked', false);
		$('._3500').prop('checked', false);
		$('.price3000YEN').addClass("disabled");
		$('.price3500YEN').addClass("disabled");

		//利用コースが選択されていない場合
	} else {
		//console.log("選択なし：活性：チェックあり");	

		$('._3000').prop('disabled', true);
		$('._3500').prop('disabled', true);
		$('._3000').prop('checked', false);
		$('._3500').prop('checked', false);
		$('.price3000YEN').addClass("disabled");
		$('.price3500YEN').addClass("disabled");
	}
}



/*
*　"calculate"ボタン押下時の処理
*/
function push_Calculate_Btn() {


	//条件① : 人数取得 (4人以上)
	var bool_1 = parseInt($('.memNum').val()) >= 4;

	//条件② : コースが夜且つチェックあり またはコースが昼：チェックなし
	var bool_2 = ($('input[name="price"]:checked').val() !== undefined && courseFlg == "NIGHT")
		|| courseFlg == "DAY";




	//入力に問題がない場合、計算実行
	if (bool_1 && bool_2) {
		//チェックOK
		//console.log("OK");

		$('#numErrMsg').text("");
		$('#courseErrMsg').text("");

		//人数取得
		var memberNum = parseInt($('.memNum').val());
		//飲み放題価格
		var nomihorice = parseInt($('input[name="nomiho"]:checked').val());
		//コース価格
		var coursePrice;

		if (courseFlg == "NIGHT") {
			coursePrice = parseInt($('input[name="price"]:checked').val());
		} else {
			coursePrice = parseInt(DAY_COURSE_PRICE);
		}

		//合計金額
		var sumPrice = memberNum * (coursePrice + nomihorice);

		//飲み放題ありの場合割引する(人数*500マイナス)
		var nomihoAri = 0;
		var nomiho = $('input[name="nomiho"]:checked').attr('id');
		if (nomiho == 'nomihoAri') {
			$('.need_one_drink').hide();
		} else {
			$('.need_one_drink').show();
		}

		//一人当たりの金額
		var onePrice = coursePrice + nomihorice;

		//クポーンの表示・非表示
		var nomiho = $('input[name="nomiho"]:checked').attr('id');
		if (nomiho == 'nomihoNashi') {
			$('.apply_coupon_price').hide();
		} else {
			$('.apply_coupon_price').show();
		}

		//計算実行
		doCalulate(sumPrice, onePrice, memberNum);


		// 店を決定していない/人数を入力していない/コースを選択していない/飲み放題を選択していない場合、
		// エラーメッセージの出力
	} else {
		//チェックNG
		//console.log("NG");


		$('#numErrMsg').text("");
		if ($('.memNum').val().length) {
			if (parseInt($('.memNum').val()) < 4) {
				$('#numErrMsg').text("※人数は4名以上を入力してください");
			}

		} else {
			$('#numErrMsg').text("※人数を入力してください");

		}


		if (!bool_2) {
			$('#courseErrMsg').text("※ご利用コースを選択してください");
		} else {
			$('#courseErrMsg').text("");
		}


		//計算結果のリフレッシュ
		refreshCalulate();
		//アラートメッセージを出力する。(※要件によって後から修正予定)

	}

}


/*
* 計算結果を画面に表示する処理　
* cpnRate : 割引率( XX ％) 
*/
function doCalulate(sumPrcBfr, onePrcBfr, memberNum) {

	//割引後の値を計算する
	var sumPrcAft = sumPrcBfr - (memberNum * 500);
	var onePrcAft = onePrcBfr - 500;

	//人数表示
	$('.aprMenNum').text(memberNum);

	//表示変更
	$('.sumPriceBfr').text(separate(sumPrcBfr));
	$('.onePriceBfr').text(separate(onePrcBfr));
	$('.sumPriceAft').text(separate(sumPrcAft));
	$('.onePriceAft').text(separate(onePrcAft));

	//8人以上の場合DOM追加
	if (memberNum >= 8) {
		addDomPrivilege();
	} else {
		deleteDomPrivilege();
	}
}

/*
* 計算結果の画面表示を初期化する処理
*/
function refreshCalulate() {
	//人数表示リセット
	$('.aprMenNum').text("-");
	//表示変更
	$('.sumPriceBfr').text("-");
	$('.onePriceBfr').text("-");
	$('.sumPriceAft').text("-");
	$('.onePriceAft').text("-");

	//DOM削除
	deleteDomPrivilege();
}


/*
* 正規表現でカンマ編集する処理
*/
function separate(num) {
	return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}


/*
*　8人以上いた場合のDom追加イベント
*/
function addDomPrivilege() {
	//表示ページのURLにより、出す画像のパスを制御。
	var page_url = location.href;
	var page = '';
	if (page_url.indexOf('utage2019spring') !== -1) {
		var page = '-2019spring';
	}
	var last_li = '<li class="over8_price"><p><img src="/wp-content/themes/joysoundcs/images/estimate/estimate-txt-over8' + page + '.png" alt="さらに！" class="sp_hidden"><img src="/wp-content/themes/joysoundcs_sp/images/estimate/estimate-txt-over8' + page + '.png" alt="さらに！" class="pc_hidden"></p><div class="estimate_result_list"><p class="result_label">8名様以上のご予約時</p><p><span class="yellow_line"><span>8人以上の予約のため</span><br class="pc_hidden"><strong class="text_red"><span>幹事様<span class="font_century">1</span>名無料！</span></strong></span></p></div></li>';
	var over8_leng = $('.apply_coupon_price').next('.over8_price').length;
	if (over8_leng == false) {
		$('.apply_coupon_price').after(last_li);
	}
}

/*
*　8人以上いなかった場合のDom削除イベント
*/
function deleteDomPrivilege() {
	var over8_leng = $('.apply_coupon_price').next('.over8_price').length;
	if (over8_leng) {
		$('.over8_price').remove();
	}
}



function smoth_scroll() {
	//条件① : 人数取得 (4人以上)
	var bool_1 = parseInt($('.memNum').val()) >= 4;

	//条件② : コースが夜且つチェックあり またはコースが昼：チェックなし
	var bool_2 = ($('input[name="price"]:checked').val() !== undefined && courseFlg == "NIGHT")
		|| courseFlg == "DAY";

	if (bool_1 && bool_2) {
		var speed = 400;
		var href = _this.attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({ scrollTop: position }, speed, 'swing');
		return false;

	} else {
		return false;

	}
}